import React, { useEffect, useRef } from 'react'
import { PaymentCard, PaymentLogo } from 'gu-ui-kit'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import PropTypes from 'prop-types'
import styles from 'components/BillingCards/BillingCards.module.scss'

const options = {
  rewind: true,
  perPage: 1,
  perMove: 1,
  padding: { right: 0 },
  arrows: false,
  pagination: false,
  drag: false,
}

export const BillingCards = ({ cards = [] }) => {
  const splideRef = useRef()

  useEffect(() => {
    const findedIndex = cards.findIndex(({ active }) => active)
    if (findedIndex > -1 && splideRef.current) {
      splideRef.current.go(findedIndex)
    }
  }, [cards, splideRef])

  return (
    <div className={styles['cards']}>
      <Splide
        ref={splideRef}
        className={styles['cards__splide']}
        options={options}
        hasTrack={false}
      >
        <SplideTrack className={styles['cards__track']}>
          {cards.map(({ id, title }) => (
            <SplideSlide key={id} className={styles['cards__slide']}>
              <PaymentCard
                icon={<PaymentLogo name={id} type={'component'} />}
                backgroundColor={`var(--network-color-${id}, #1c84ff)`}
                color={`var(--network-color-${id}, #1c84ff)`}
                type={'default'}
                name={id}
                title={title}
              >
                <div className={styles['cards__slide-heading']}>{title}</div>
              </PaymentCard>
            </SplideSlide>
          ))}
        </SplideTrack>
      </Splide>
    </div>
  )
}

BillingCards.propTypes = {
  cards: PropTypes.array,
}
